import { mapGetters } from 'vuex'
import { editorManuscript } from '@/api/editor'
import mauthor from '@/api/mauthor'
import { AUTHOR_STATUS } from '@/utils/dict'
import AuthorQuestionnaire from '../dialog/author-questionnaire.dialog'

const authorColumns = [
  {
    title: '',
    enTitle: 'Order',
    width: 50,
    dataIndex: 'seq'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 120,
    dataIndex: 'email',
    slot: 'email'
    // slot: 'omis'
  },
  {
    title: '',
    enTitle: 'ORCID',
    width: 160,
    dataIndex: 'orcid',
    slot: 'orcid'
  },
  {
    title: '',
    enTitle: 'Affiliation',
    width: 160,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Country',
    width: 150,
    dataIndex: 'countryCode',
    slot: 'country'
  }
]
const columns = [
  {
    title: '',
    enTitle: '',
    width: 50,
    dataIndex: 'id',
    slot: 'checkbox'
  },
  {
    title: '',
    enTitle: 'Order',
    width: 50,
    dataIndex: 'seq'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 120,
    dataIndex: 'email',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'ORCID',
    width: 160,
    dataIndex: 'orcid',
    slot: 'orcid'
  },
  {
    title: '',
    enTitle: 'Affiliation',
    width: 160,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Country',
    width: 150,
    dataIndex: 'countryCode',
    slot: 'country'
  },
  {
    title: '',
    enTitle: 'Confirmation',
    width: 120,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    fixed: 'right',
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: { AuthorQuestionnaire },
  data() {
    return {
      authorColumns,
      columns,
      AUTHOR_STATUS,
      showAuthorQuestionnaire: false,
      sign: '',
      id: '',
      articleDetail: {
        signList: []
      },
      author: [],
      inputData: {},
      dataSource: [],
      selectList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      country: 'getCountry',
      user: 'getUser'
    })
  },
  mounted() {
    this.sign = this.$route.query.sign
    this.id = this.$route.params.id
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.articleDetail = await editorManuscript.query(this.id, {
        sign: this.sign
      })
      this.author = await mauthor.get({
        manuscriptId: this.id,
        sign: this.sign,
        submited: true
      })
      this.getList()
    },
    async getList() {
      this.dataSource = await mauthor.get({
        manuscriptId: this.id,
        sign: this.sign,
        submited: false
      })
    },
    async sendLetter(val) {
      await mauthor.resend(val ? val.id : this.selectList.join(','))
      this.$message.success({
        title: 'Success',
        content: 'Resend Email Successfully'
      })
      this.selectList = []
      this.getList()
    },
    viewQuestionnaire(val) {
      this.inputData = val
      this.showAuthorQuestionnaire = true
    },
    async reset(val) {
      const { id, version } = val
      await mauthor.reset(id, { version })
      this.$message.success({
        title: 'Success',
        content: 'Reset Confirmation Status Successfully'
      })
      this.getList()
    },
    cancel() {
      this.showAuthorQuestionnaire = false
    },
    onSelectChange(val) {
      const index = this.selectList.findIndex(item => {
        return val === item
      })
      if (index === -1) {
        this.selectList.push(val)
      } else {
        this.selectList.splice(index, 1)
      }
    }
  }
}
